export const WAS_SELECTED = "WAS_SELECTED";
export const WAS_DOUBLE_CLICK = "WAS_DOUBLE_CLICK";
export const SEARCH = "SEARCH";

export const CHANGED_DESCRIPTION = "CHANGED_DESCRIPTION";
export const CHANGED_VALUE = "CHANGED_VALUE";
export const CHANGED_SELECTED_RESOURCES = "CHANGED_SELECTED_RESOURCES";
export const LOAD_RESOURCES = "LOAD_RESOURCES";
export const CHANGED_SELECTED_APPLICATIONS = "CHANGED_SELECTED_APPLICATIONS";
export const LOAD_APPLICATIONS = "LOAD_APPLICATIONS";
export const CHANGED_PANEL_BODY = "CHANGED_PANEL_BODY";
export const SEARCH_PANEL_FILTERS = "SEARCH_PANEL_FILTERS";